import React from 'react';
import type { VarianceTableWidgetConfig } from './types';

interface Props {
  config: VarianceTableWidgetConfig;
  onChange?: (config: VarianceTableWidgetConfig) => void;
}

const VarianceTableWidgetBuilder: React.FC<Props> = () => (
  <div className="p-4 text-sm text-neutral-500">
    The variance table renders automatically for the assigned asset — no configuration needed.
  </div>
);

export default VarianceTableWidgetBuilder;
